export default "__VITE_ASSET__f2f3d8a9__"